import {FaX} from "react-icons/fa6";
import Button from "../../../../../../components/button/button.jsx";
import {FaFolderOpen} from "react-icons/fa";
import occurrenceService from "../../../../../../services/web/occurrence-service.js";
import {toast} from "react-toastify";

const openInSentryView = async (id) => {
  occurrenceService.openSentryViewOccurrence(id).then(() => {
    toast.success(`A ocorrência ${id} será aberta no SentryView`)
  })
    .catch(e => {
      console.error(e)
      toast.error('Não foi possível abrir a ocorrência no SentryView');
    });
}

const GenerateForm = (data, setActiveId) => {

  return (
    <div id={`${data.id}-detail`} className="z-[10000] p-2">
      <div className="flex justify-between items-center">
        <span className="text-[24px] py-4">{data.reason_plate}</span>
        <div className="py-1 px-2 cursor-pointer" onClick={() => setActiveId(null)}>
          <FaX/>
        </div>
      </div>
      <span className="py-2 mt-2">{data.address}</span>
      <div className="w-full border-b border-b-[#d9dada] my-2"></div>
      <div className="flex flex-col py-2 gap-2">
        <span className="font-bold">Fato ocorrido entre:</span>
        <span className="">{data.fact_range}</span>
      </div>
      <div className="w-full border-b border-b-[#d9dada] my-2"></div>
      <div className="flex flex-col py-2 gap-2">
        <span className="font-bold">Descrição:</span>
        <span className="font-light">{data.description}</span>
      </div>
      <div className="w-full border-b border-b-[#d9dada] my-2"></div>
      <div className="flex justify-between items-start py-2">
        <span className="font-light">{data.visibility}</span>
        <Button className="ml-1" onClick={() => openInSentryView(data.occurrence_id)}><FaFolderOpen/> Abrir ocorrência</Button>
      </div>
    </div>
  )
}

export default GenerateForm